import Alerts from 'lib/alerts';
import Payrolls from 'newCollections/payrolls.js';

const freeAccountSetupRequest = () => {
    const request = () => Alerts.show('success', {
        title: '',
        text: `Get payroll assistance with account setup and full ` +
        `onboarding by calling +603 2787 9168.`,
        confirmButtonText: 'OK'
    });

    return request()
        .then(() => app.company.fetch({validate: false}));
};

const shouldShowFreeSetup = () => {
    return Promise.all([
        app.company.fetch(),
        new Payrolls(null, {company: app.company}).count()
    ]).then(([company, count]) => {
        const role = app.user.get('role');
        const isMpp = ['mpp_admin', 'mpp_manager'].includes(role);
        const lessThanOnePayroll = count <= 1;
        const show = lessThanOnePayroll && !isMpp;
        return show;
    });
};

module.exports = {
    freeAccountSetupRequest,
    shouldShowFreeSetup
};



// WEBPACK FOOTER //
// ./app/commons/views/FreeAccountSetup.js